import moment from "moment";
import React, { Fragment } from "react";
import Icon from "../common/Icon";
import { TextArea } from "../common/Forms";

const LectureView = (props) => {
  const { title, date, place, info, curriculum, host, report, className } =
    props;
  return (
    <div className={className}>
      <div className="p-4 bg-cyan-500 ">
        <div className="mx-auto md:w-full md:mx-0">
          <header className="flex-1 w-full text-3xl text-white font-bold">
            {title}
          </header>
        </div>
      </div>
      <div className="space-y-6 rounded-b-lg bg-white pb-6">
        <hr />
        <div className="items-center w-full px-4 space-y-0 md:space-y-4">
          <h2 className="mx-auto text-lg font-bold">
            <Icon
              name="calendar-days"
              className="text-cyan-500 inline-block mr-1 mb-[2px]"
            />
            수업 일시
          </h2>
          {"_isAMomentObject" in date[0] && (
            <div className="inline-flex flex-wrap items-center gap-2 py-2">
              <p className="flex-initial">{date[0].format("LLL")}</p>
              <span> ~ </span>
              <p>{date[1].format("LLL")}</p>
            </div>
          )}
        </div>
        <hr />
        <div className="items-center w-full px-4 space-y-0 md:space-y-4">
          <h2 className="mx-auto text-lg font-bold">
            <Icon
              name="map-pin"
              className="text-cyan-500 inline-block mr-1 mb-[2px]"
            />
            수업 장소
          </h2>
          <p className="py-2">{place}</p>
        </div>
        <hr />
        <div className="items-center w-full px-4 space-y-0 md:space-y-4">
          <h2 className="mx-auto text-lg font-bold">
            <Icon
              name="information-circle"
              className="text-cyan-500 inline-block mr-1 mb-[2px]"
            />
            수업 정보
          </h2>
          <div className="flex flex-col gap-2 py-2">
            {info.map(({ label, content }, i) => (
              <div
                className="inline-flex items-baseline gap-2"
                key={`info_${i}`}
              >
                <p className="font-bold text-right text-sm flex-grow-0 flex-shrink-0 basis-24">
                  {label}
                </p>
                <p>{content}</p>
              </div>
            ))}
          </div>
        </div>
        <hr />
        <div className="items-center w-full px-4 space-y-0 md:space-y-4">
          <h2 className="mx-auto text-lg font-bold">
            <Icon
              name="queue-list"
              className="text-cyan-500 inline-block mr-1 mb-[2px]"
            />
            커리큘럼
          </h2>
          <ul className="flex flex-col gap-2">
            {curriculum.map(({ content, list, datetime }, i) => {
              const tRows = list.reduce(
                (r, cur) => cur.items.length + r,
                2 + list.length
              );
              return (
                <li
                  key={`curr_${i}`}
                  className="rounded-md overflow-hidden border border-accent border-solid"
                >
                  <table className="w-full">
                    <tbody>
                      <tr>
                        <td
                          rowSpan={tRows}
                          className="text-center py-1 bg-accent text-white w-[72px]"
                        >
                          {`${i + 1}회차`}
                        </td>
                        <td colSpan={3} className="py-1 px-2 font-bold">
                          {content}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="py-1 px-2">
                          <div className="inline-flex flex-wrap gap-1 opacity-75">
                            <span>
                              {new moment(datetime.date)
                                .set("hour", datetime.start.hour)
                                .set("minute", datetime.start.min)
                                .format("LLL")}
                            </span>
                            <span>~</span>
                            <span>
                              {new moment(datetime.date)
                                .set("hour", datetime.end.hour)
                                .set("minute", datetime.end.min)
                                .format("LLL")}
                            </span>
                          </div>
                        </td>
                      </tr>
                      {list.map(({ subject, items }, j) => (
                        <Fragment key={`curr_${i}_${j}`}>
                          <tr>
                            <td
                              rowSpan={items.length + 1}
                              className="align-baseline font-bold text-sm text-right"
                            >
                              {`${j + 1}.`}
                            </td>
                            <td className="align-baseline font-bold text-sm w-16 py-1">
                              학습 주제
                            </td>
                            <td className="py-1">{subject}</td>
                          </tr>
                          {items.map((v, k) => (
                            <tr key={`curr_${i}_${j}_${k}`}>
                              {k === 0 && (
                                <td
                                  rowSpan={items.length}
                                  className="align-baseline font-bold text-sm w-16 py-1"
                                >
                                  학습 내용
                                </td>
                              )}
                              <td className="py-1">{v}</td>
                            </tr>
                          ))}
                        </Fragment>
                      ))}
                    </tbody>
                  </table>
                </li>
              );
            })}
          </ul>
        </div>
        {report && <hr />}
        {report && (
          <div className="items-center w-full px-4 space-y-0 md:space-y-4">
            <h2 className="mx-auto text-lg font-bold">
              <Icon
                name="map-pin"
                className="text-cyan-500 inline-block mr-1 mb-[2px]"
              />
              리포트 요약
            </h2>
            <TextArea
              className="flex-1 w-full p-2 bg-white shadow-sm text-sm"
              rows={3}
              value={report.join("\n")}
              readOnly={true}
            ></TextArea>
          </div>
        )}
        <hr />
        <div className="items-center w-full px-4 space-y-0 md:space-y-4">
          <h2 className="mx-auto text-lg font-bold">
            <Icon
              name="map-pin"
              className="text-cyan-500 inline-block mr-1 mb-[2px]"
            />
            주최 정보
          </h2>
          <p className="py-2">{host}</p>
        </div>
      </div>
    </div>
  );
};

export default LectureView;
